import FiltrarPagos from '../../../components/ui/Admin/FiltrarPagosComponents/FiltrarPagos';

const FiltrarPagosUI = () => {
  return (
    <div className="pb-4">
      <FiltrarPagos />
    </div>
  );
};

export default FiltrarPagosUI;
